import type { VariantSanityImage } from '../product-variant.types';
import { urlFor } from '@/sanity/lib/image';

/**
 * Converts a Sanity image to the format expected by VariantItem
 */
export const toImageField = (
  img: VariantSanityImage | null | undefined,
): {
  asset: { url: string };
} => {
  try {
    if (!img?.asset?._ref) {
      return { asset: { url: '' } };
    }
    const url = urlFor(img).width(800).quality(85).url();
    return { asset: { url: url } };
  } catch {
    return { asset: { url: '' } };
  }
};
